import { useTranslation } from 'react-i18next';

import logo from '@assets/logos/astropay-logo.png';
import { APButton } from '@components/atoms/APButton';
import { APImage } from '@components/atoms/APImage';
import { Typography } from '@components/atoms/Typography';

export const ErrorBoundaryDescription = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen w-full justify-center items-center flex flex-col bg-[#F3F6F6] p-8">
      <div className="flex flex-col min-h-screen max-w-sm text-center justify-center items-center">
        <APImage
          img={logo}
          width={114}
          height={29}
          alt={t('AstroPayDownload.title')}
          className="mb-3"
        />

        <Typography
          text={t('CommonMessages.errorMessages.somethingWentWrong')}
          className="text-sm text-red-600"
        />
        <Typography
          text={t('CommonMessages.errorMessages.tryReloadingPage')}
          className="text-sm text-gray-500 m-2"
        />
        <APButton textKey="CommonMessages.reloadPage" onClick={() => window.location.reload()} />
      </div>
    </div>
  );
};
